import { contactData } from '@/mocks/home';

export default function ContactSection() {
  const item = contactData[0];

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            联系我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500">商务合作、版权洽谈与读者反馈通道</p>
        </div>

        <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
          <h3 className="font-heading text-xl text-foreground-950 mb-5">{item.title}</h3>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            {item.items.map((i) => (
              <div
                key={i.label}
                className="flex items-center gap-3 p-4 rounded-xl bg-background-100 border border-background-200/70"
              >
                <div className="w-10 h-10 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">
                  <i className={`${i.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                </div>
                <div className="min-w-0">
                  <span className="text-xs text-foreground-400">{i.label}</span>
                  <p className="text-sm text-foreground-800 font-medium truncate">{i.value}</p>
                </div>
              </div>
            ))}
          </div>

          <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
        </div>
      </div>
    </section>
  );
}